import { render } from "./PageHeader.vue?vue&type=template&id=326f09ca&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=326f09ca&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326f09ca"]])

export default __exports__